<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="Part_1">
<h1 class="ptnumber"><a href="#/text/9780062295552_Contents#Part_1">PART ONE</a></h1>
<h1 class="pttitle"><strong class="b"><em class="i">January 1943</em></strong></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062295552_Part_1.vue?3d88f1a7